var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isFixedWireless)?_c('FixedWireless',{attrs:{"service":_vm.service}}):_vm._e(),(_vm.isPOI)?_c('Poi',{attrs:{"service":_vm.service}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }